const getters = {
  sidebar: (state) => state.buyMerchant.apiMerchant,
  // buyPaymentParams:state => state.buyPayments.buyPaymentParams,
  // buyForm:state => state.buyPayments.buyForm,
};
export default getters;
